;(() => {
  if (window.dkPackageCartInstalled || typeof CartItems === 'undefined') return;
  window.dkPackageCartInstalled = true;
  const root = window.Shopify?.routes?.root || '/';
  const products = new Map();
  const unitModel = 'original-variants-v3';
  const modelAttributes = cart => ({...(cart.attributes || {}), _smileora_unit_model: unitModel});
  const isUnitCart = cart => cart?.attributes?._smileora_unit_model === unitModel;
  const legacyUnits = (id, cart) => isUnitCart(cart) ? 1 : (({53571206676661: 2, 53571206709429: 3})[id] || 1);
  const retiredOfferUnits = () => 0;
  const offerIds = [53571206643893, 53571206676661, 53571206709429];
  let codProductSelection;
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.es-popup-button-product');
    if (!button) return;
    const picker = button.closest('main')?.querySelector('variant-selects');
    const selected = picker?.querySelector('input[type="radio"]:checked');
    const json = picker?.querySelector('script[type="application/json"]');
    if (!selected || !json) return;
    const variant = JSON.parse(json.textContent).find(v => v.options[0] === selected.value);
    const index = offerIds.indexOf(variant?.id);
    if (index >= 0) codProductSelection = {id: variant.id, units: index + 1, expires: Date.now() + 15000};
  }, true);
  // Old packet IDs are migration inputs only. Every new cart quantity is a device.

  let busy = false;
  let currentCart;
  const request = async (path, body) => {
    const response = await nativeFetch(root + path, body ? {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)} : {headers: {Accept: 'application/json'}, cache: 'no-store'});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) throw new Error(typeof data.errors === 'string' ? data.errors : data.description || data.message || window.cartStrings?.error || 'Sepet güncellenemedi.');
    return data;
  };
  const packageUnits = title => {
    const match = String(title || '').match(/(?:^|\s|[–-])(\d{1,2})(?=\s|$)/);
    return match ? Number(match[1]) : 1;
  };
  const getPackages = async item => {
    if (item.handle !== 'smileora™-sicak-suyla-sekillendirilen-gecici-disler' || item.selling_plan_allocation || Object.keys(item.properties || {}).length) return null;
    if (!products.has(item.handle)) products.set(item.handle, request('products/' + encodeURIComponent(item.handle) + '.js').catch(error => {products.delete(item.handle); throw error;}));
    const product = await products.get(item.handle);
    if (product.options.length !== 1 || product.variants.length < 2) return null;
    const variants = offerIds.map((id, index) => {
      const v = product.variants.find(v => v.id === id);
      if (!v) throw new Error('Ürün seçenekleri güncelleniyor. Lütfen sayfayı yenileyin.');
      return {id: v.id, units: index + 1, price: v.price, available: v.available};
    });
    return variants;
  };
  const bestPackages=(units,variants)=>{const costs=Array(units+1).fill(Infinity),choice=Array(units+1);costs[0]=0;for(let n=1;n<=units;n++)for(const v of variants){if(v.available&&v.units<=n&&costs[n-v.units]+v.price<costs[n]){costs[n]=costs[n-v.units]+v.price;choice[n]=v;}}if(!Number.isFinite(costs[units]))throw new Error('Stok yetersiz.');const counts=new Map();for(let n=units;n>0;){const v=choice[n];counts.set(v.id,(counts.get(v.id)||0)+v.units);n-=v.units;}return counts;};
  const syncQuantities = async cart => {
    currentCart = cart;
    scheduleEasySummary();
    await Promise.all(cart.items.map(async (item, index) => {
      const variants = await getPackages(item);
      if (!variants) return;
      const units = legacyUnits(item.variant_id, cart);
      const quantity = cart.items.filter(i => i.variant_id === item.variant_id && !i.selling_plan_allocation && !Object.keys(i.properties || {}).length).reduce((sum, i) => sum + i.quantity * units, 0);
      for (const id of ['Quantity-' + (index+1), 'Drawer-quantity-' + (index+1)]) {
        const input = document.getElementById(id);
        if (!input) continue;
        input.value = quantity;
        input.defaultValue = quantity;
        input.min = 0;
        input.step = 1;
        input.removeAttribute('max');
        input.dataset.dkUnits = String(units);
      }
    }));
  };
  const showError = message => {
    for (const id of ['cart-errors', 'CartDrawer-CartErrors']) {
      const node = document.getElementById(id);
      if (node) node.textContent = message;
    }
  };
  const render = async (owner, cart, sections) => {
    let htmlSections = cart.sections;
    if (!htmlSections || sections.some(s => !htmlSections[s.section])) htmlSections = await request('?sections=' + encodeURIComponent(sections.map(s => s.section).join(',')));
    for (const section of sections) {
      const host = document.getElementById(section.id);
      const html = htmlSections[section.section];
      if (!host || !html) continue;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector(section.selector || '.shopify-section');
      const target = host.querySelector(section.selector || '.shopify-section') || host;
      if (source && target) target.innerHTML = source.innerHTML;
      cartObserver?.takeRecords();
    }
    for (const node of document.querySelectorAll('cart-items, cart-drawer, cart-drawer-items, #main-cart-footer')) node.classList.toggle('is-empty', cart.item_count === 0);
    showError('');
    await syncQuantities(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart}}));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items', cartData: cart});
  };
  CartItems.prototype.updateQuantity = async function(line, quantity, name) {
    if (busy) return;
    const wanted = Number(quantity);
    if (!Number.isInteger(wanted) || wanted < 0 || wanted > 999) {if (currentCart) await syncQuantities(currentCart);return;}
    busy = true;
    showError('');
    const controls = [...document.querySelectorAll('cart-items input[type="number"], cart-items button, cart-drawer-items input[type="number"], cart-drawer-items button, [name="checkout"]')].filter(el => !el.disabled);
    controls.forEach(el => el.disabled = true);
    this.setAttribute('aria-busy', 'true');
    try {
      const cart = await request('cart.js');
      const item = cart.items[Number(line)-1];
      if (!item) {await syncQuantities(cart);return;}
      const sections = this.getSectionsToRender().filter(s => document.getElementById(s.id));
      const shared = {sections: [...new Set(sections.map(s => s.section))].slice(0,5), sections_url: location.pathname};
      const variants = await getPackages(item);
      let updated;
      if (variants) {
        const group = cart.items.filter(i => i.product_id === item.product_id && !i.selling_plan_allocation && Object.keys(i.properties || {}).length === 0);
        const units = wanted + group.filter(i => i.variant_id !== item.variant_id).reduce((sum, i) => sum + i.quantity * (legacyUnits(i.variant_id, cart)), 0);
        const counts = bestPackages(units, variants);
        const updates = {};
        for (const old of group) {updates[old.key] = counts.get(old.variant_id) || 0; counts.delete(old.variant_id);}
        for (const [id, count] of counts) updates[String(id)] = count;
        updated = await request('cart/update.js', {updates, attributes: modelAttributes(cart), ...shared});
      } else updated = await request('cart/change.js', {id: item.key, quantity: wanted, ...shared});
      await render(this, updated, sections);
      await assertPhysicalPricing(updated);
    } catch (error) {
      showError(error.message || window.cartStrings?.error || 'Sepet güncellenemedi.');
      try {await syncQuantities(await request('cart.js'));} catch (_) {}
    } finally {
      controls.forEach(el => {if (el.isConnected) el.disabled = false;});
      for (const node of document.querySelectorAll('cart-items, cart-drawer-items')) {node.removeAttribute('aria-busy');node.classList.remove('cart__items--disabled');}
      document.querySelectorAll('.loading__spinner').forEach(el => el.classList.add('hidden'));
      busy = false;
    }
  };
  let quantityInputTimer;
  const handleQuantityInput = event => {
    const input=event.target;
    if(!input.matches('cart-items input[name="updates[]"],cart-drawer-items input[name="updates[]"]'))return;
    event.stopImmediatePropagation();
    clearTimeout(quantityInputTimer);
    const commit=()=>{
      if(!input.isConnected||input.value==='')return;
      const owner=input.closest('cart-drawer-items,cart-items');
      owner?.updateQuantity(input.dataset.index,Number(input.value),input.getAttribute('name'));
    };
    if(event.type==='change')commit();else quantityInputTimer=setTimeout(commit,600);
  };
  document.addEventListener('input',handleQuantityInput,true);
  document.addEventListener('change',handleQuantityInput,true);
  let nativeSubmitVerified = false;
  document.addEventListener('submit', event => {
    if (!['cart','CartDrawer-Form'].includes(event.target.id)) return;
    if (nativeSubmitVerified) { nativeSubmitVerified = false; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    const formId = event.target.id;
    const submitterName = event.submitter?.name;
    window.fetch(root + 'cart/update.json').then(response => {
      if (!response.ok) throw new Error('Sepet doğrulanamadı.');
      const form = document.getElementById(formId);
      if (!form) throw new Error('Sepet yenilendi. Lütfen tekrar deneyin.');
      const button = submitterName === 'checkout' ? (form.querySelector('[name="checkout"]') || document.querySelector('[form="' + formId + '"][name="checkout"]')) : undefined;
      nativeSubmitVerified = true;
      const quantities = [...form.querySelectorAll('[name="updates[]"]')];
      quantities.forEach(input => input.disabled = true);
      try { form.requestSubmit(button || undefined); }
      finally { nativeSubmitVerified = false; quantities.forEach(input => input.disabled = false); }
    }).catch(error => showError(error.message));
  }, true);
  const normalizeCart = async cart => {
    if (busy) return;
    const updates = {}, seen = new Set();
    for (const item of cart.items) {
      if (seen.has(item.product_id)) continue;
      seen.add(item.product_id);
      const variants = await getPackages(item);
      if (!variants) continue;
      const group = cart.items.filter(i => i.product_id === item.product_id && !i.selling_plan_allocation && !Object.keys(i.properties || {}).length);
      const units = group.reduce((n,i) => n + i.quantity * (legacyUnits(i.variant_id, cart)),0);
      if (units > 999) continue;
      const counts = bestPackages(units,variants);
      const actual = new Map();
      for (const i of group) actual.set(i.variant_id, (actual.get(i.variant_id) || 0) + i.quantity);
      if (actual.size === counts.size && [...actual].every(([id, q]) => counts.get(id) === q)) continue;
      for (const old of group) {updates[old.key]=counts.get(old.variant_id)||0;counts.delete(old.variant_id);}
      for (const [id,q] of counts) updates[String(id)]=q;
    }
    if (!Object.keys(updates).length && isUnitCart(cart)) return syncQuantities(cart);
    const owner = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (!owner) return;
    busy=true;
    const checkoutControls=[...document.querySelectorAll('[name="checkout"], #CartDrawer-Checkout')].filter(el=>!el.disabled);
    checkoutControls.forEach(el=>el.disabled=true);
    try {
      const sections=owner.getSectionsToRender().filter(s=>document.getElementById(s.id));
      const updated=await request('cart/update.js',{updates,attributes:modelAttributes(cart),sections:[...new Set(sections.map(s=>s.section))].slice(0,5),sections_url:location.pathname});
      await render(owner,updated,sections);
    } catch(error) {showError(error.message);throw error;}
    finally {busy=false;checkoutControls.forEach(el=>{if(el.isConnected)el.disabled=false;});}
  };

  const assertPhysicalPricing = async cart => {
    products.clear();
    if (cart.currency && cart.currency !== 'TRY') throw new Error('Sepet para birimi doğrulanamadı.');
    const group = cart.items.filter(i => i.handle === 'smileora™-sicak-suyla-sekillendirilen-gecici-disler' && !i.selling_plan_allocation && !Object.keys(i.properties || {}).length);
    if (!group.length) return;
    if (group.some(i => legacyUnits(i.variant_id, cart) !== 1)) throw new Error('Sepet adetleri henüz güncellenmedi. Lütfen tekrar deneyin.');
    const variants = await getPackages(group[0]);
    const counts = bestPackages(group.reduce((sum, i) => sum + i.quantity, 0), variants);
    const expected = [...counts].reduce((sum, [id, q]) => {
      const v = variants.find(v => v.id === id);
      return sum + q / v.units * v.price;
    }, 0);
    const actual = group.reduce((sum, i) => sum + i.final_line_price, 0);
    if (!Number.isSafeInteger(actual) || actual !== expected) {
      throw new Error('Paket indirimi doğrulanamadı. Lütfen sepeti yenileyip tekrar deneyin.');
    }
  };
  const preparePhysicalAdd = async body => {
    products.clear();
    const variants = await getPackages({handle: 'smileora™-sicak-suyla-sekillendirilen-gecici-disler'});
    const convert = item => {
      const id = Number(item.id);
      const tier = variants.find(v => v.id === id) || variants.find(v => v.units === retiredOfferUnits(id));
      if (!tier) return item;
      const quantity = Number(item.quantity ?? 1) * tier.units;
      if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > 999) throw new Error('Geçersiz ürün adedi.');
      return {...item, id: tier.id, quantity};
    };
    if (typeof body === 'string') {
      const data = JSON.parse(body);
      return JSON.stringify(data.items ? {...data, items: data.items.map(convert)} : convert(data));
    }
    if (body instanceof FormData || body instanceof URLSearchParams) {
      const copy = body instanceof FormData ? new FormData() : new URLSearchParams();
      for (const [key, value] of body.entries()) copy.append(key, value);
      if (copy.has('id')) {
        const item = convert({id: copy.get('id'), quantity: copy.get('quantity') ?? 1});
        copy.set('id', String(item.id)); copy.set('quantity', String(item.quantity));
      } else {
        for (const key of [...copy.keys()]) {
          const match = key.match(/^items\[(\d+)\]\[id\]$/);
          if (!match) continue;
          const quantityKey = 'items[' + match[1] + '][quantity]';
          const item = convert({id: copy.get(key), quantity: copy.get(quantityKey) ?? 1});
          copy.set(key, String(item.id)); copy.set(quantityKey, String(item.quantity));
        }
      }
      return copy;
    }
    throw new Error('Sepete ekleme isteği doğrulanamadı. Lütfen sayfayı yenileyin.');
  };
  // EasySell uses both a cart read and an update response to build its COD form.
    let codReading = false, codQueue = Promise.resolve();
      const nativeFetch = window.fetch.bind(window);
        window.fetch = (input, init) => {
              const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
                  const method = String(init?.method || input?.method || 'GET').toUpperCase();
                  if (url.origin === location.origin && method === 'POST' && [root + 'cart/add', root + 'cart/add.js', root + 'cart/add.json'].includes(url.pathname)) {
                    const add = async () => {
                      const deadline = Date.now() + 8000;
                      while (busy || syncInFlight) {
                        if (Date.now() > deadline) throw new Error('Sepet güncelleniyor. Lütfen tekrar deneyin.');
                        await new Promise(resolve => setTimeout(resolve, 50));
                      }
                      codReading = true;
                      try {
                        await normalizeCart(await request('cart.js'));
                        const body = await preparePhysicalAdd(init?.body);
                        const response = await nativeFetch(input, {...init, body});
                        if (!response.ok) return response;
                        const result = await response.json();
                        await normalizeCart(await request('cart.js'));
                        await assertPhysicalPricing(await request('cart.js'));
                        if (result.sections && Object.keys(result.sections).length) {
                          result.sections = await request('?sections=' + encodeURIComponent(Object.keys(result.sections).join(',')));
                        }
                        return new Response(JSON.stringify(result), {status: response.status, headers: {'Content-Type': 'application/json'}});
                      } finally { codReading = false; }
                    };
                    const result = codQueue.then(add, add);
                    codQueue = result.then(() => {}, () => {});
                    return result;
                  }

                      let update = false;
                          if (method === 'POST' && url.pathname === root + 'cart/update.js' && typeof init?.body === 'string') {try {const body = JSON.parse(init.body);update = !!body.updates && !body.sections;} catch (_) {}}
                              if (url.origin !== location.origin || !(url.pathname === root + 'cart/update.json' && method === 'GET' || update)) return nativeFetch(input, init);
                                  const read = async () => {
                                          const deadline = Date.now() + 8000;
                                                while (busy || syncInFlight) {if (Date.now() > deadline) throw new Error('Sepet güncelleniyor. Lütfen tekrar deneyin.');await new Promise(resolve => setTimeout(resolve, 50));}
                                                      codReading = true;
                                                            try {
                                                                      if (update) {
                                                                        await normalizeCart(await request('cart.js'));
                                                                        let updateInit = init;
                                                                        const selected = codProductSelection;
                                                                        if (selected && selected.expires > Date.now()) {
                                                                          const data = JSON.parse(init.body);
                                                                          const keys = Object.keys(data.updates);
                                                                          if (keys.length === 1 && (offerIds.includes(Number(keys[0])) || retiredOfferUnits(keys[0]) > 1)) {
                                                                            const quantity = (Number(data.updates[keys[0]]) || 1) * selected.units;
                                                                            data.updates = physicalSelectionUpdates(await request('cart.js'), selected.id, quantity);
                                                                            updateInit = {...init, body: JSON.stringify(data)};
                                                                            codProductSelection = null;
                                                                          }
                                                                        }
                                                                        const updateData = JSON.parse(updateInit.body);
                                                                        if (Object.keys(updateData.updates).some(id => offerIds.includes(Number(id)))) {
                                                                          updateData.updates = expandEasyVariantUpdates(await request('cart.js'), updateData.updates);
                                                                          updateInit = {...updateInit, body: JSON.stringify(updateData)};
                                                                        }
                                                                        const response = await nativeFetch(input, updateInit);
                                                                        if (!response.ok) return response;
                                                                      }
                                                                              products.clear();
                                                                              await normalizeCart(await request('cart.js'));
                                                                              const verifiedCart = await request('cart.js');
                                                                              await assertPhysicalPricing(verifiedCart);
                                                                              if (update) {
                                                                                const owner = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
                                                                                if (owner) await render(owner, verifiedCart, owner.getSectionsToRender().filter(s => document.getElementById(s.id)));
                                                                              }
                                                                              // Return the fresh cart we just verified. A second GET to
                                                                              // update.json can reuse an older browser-cached quantity.
                                                                              await syncQuantities(verifiedCart);
                                                                              return new Response(JSON.stringify(verifiedCart), {status:200, headers:{'Content-Type':'application/json', 'Cache-Control':'no-store'}});
                                                            } finally {codReading = false;}
                                  };
                                      const result = codQueue.then(read, read);codQueue = result.then(() => {}, () => {});return result;
        };

  function physicalSelectionUpdates(cart, variantId, quantity) {
    const updates = {};
    let assigned = false;
    for (const item of cart.items) {
      if (item.product_id !== 10641414979765 || item.selling_plan_allocation || Object.keys(item.properties || {}).length) continue;
      if (item.variant_id === variantId && !assigned) {
        updates[item.key] = quantity;
        assigned = true;
      } else updates[item.key] = 0;
    }
    if (!assigned) updates[variantId] = quantity;
    return updates;
  }
  function expandEasyVariantUpdates(cart, requested) {
    const updates = {...requested};
    for (const [id, quantity] of Object.entries(requested)) {
      if (![53571206676661, 53571206709429].includes(Number(id))) continue;
      const lines = cart.items.filter(item => item.variant_id === Number(id));
      if (lines.length < 2) continue;
      delete updates[id];
      lines.forEach((item, index) => {updates[item.key] = index === 0 ? quantity : 0;});
    }
    return updates;
  }
  function easyAmount(text) {
    const value = String(text || '').replace(/[^\d.,-]/g, '');
    if (!value || value.includes('-')) return null;
    const decimal = value.match(/[.,](\d{2})$/);
    const whole = (decimal ? value.slice(0, -3) : value).replace(/[.,]/g, '');
    const cents = Number(whole) * 100 + Number(decimal?.[1] || 0);
    return Number.isSafeInteger(cents) ? cents : null;
  }
  function easyGroup(variantId, rows, items) {
    if (![53571206676661, 53571206709429].includes(variantId) || rows.length < 1) return null;
    const lines = items.filter(item => item.variant_id === variantId);
    if (lines.length !== rows.length || lines.some(item => item.selling_plan_allocation || Object.keys(item.properties || {}).length)) return null;
    if (rows.some(row => !Number.isSafeInteger(row.quantity) || row.quantity < 1 || row.price === null)) return null;
    const quantity = lines.reduce((sum, item) => sum + item.quantity, 0);
    const price = lines.reduce((sum, item) => sum + item.final_line_price, 0);
    if (quantity !== rows.reduce((sum, row) => sum + row.quantity, 0) || price !== rows.reduce((sum, row) => sum + row.price, 0)) return null;
    return {quantity, price};
  }
  let easyObserver, easyScheduled = false;
  const easyOriginalAria = new WeakMap();
  const easyWatch = () => easyObserver.observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['href', 'data-product-id']});
  const renderEasySummary = () => {
    if (!easyObserver) return;
    easyObserver.disconnect();
    try {
      document.querySelectorAll('[data-dk-es-group]').forEach(row => row.remove());
      document.querySelectorAll('[data-dk-es-original]').forEach(row => {
        row.removeAttribute('data-dk-es-original');
        const aria = easyOriginalAria.get(row);
        if (aria === null || aria === undefined) row.removeAttribute('aria-hidden');
        else row.setAttribute('aria-hidden', aria);
      });
      if (!currentCart?.items) return;
      const parents = new Set([...document.querySelectorAll('.es-line-item[data-product-id="10641414979765"]')].map(row => row.parentElement));
      for (const parent of parents) {
        const groups = new Map();
        const originalRows = [...parent.children].filter(row => row.matches('.es-line-item'));
        for (const row of originalRows) {
          const link = row.querySelector('.es-product-title-link');
          const quantity = Number(row.querySelector('.quantity-badge')?.textContent.trim());
          const price = easyAmount(row.querySelector('.es-p-price > .fw-bold')?.textContent);
          const variantId = Number(new URL(link?.getAttribute('href') || '/', location.origin).searchParams.get('variant'));
          if (!groups.has(variantId)) groups.set(variantId, []);
          groups.get(variantId).push({node:row, quantity, price});
        }
        const combined = [...groups].map(([id, rows]) => ({rows, summary:easyGroup(id, rows, currentCart.items)})).filter(group => group.summary);
        const displayedCount = originalRows.length - combined.reduce((sum, group) => sum + group.rows.length - 1, 0);
        for (const {rows, summary} of combined) {
          const original = rows[0].node;
          const row = original.cloneNode(true);
          row.setAttribute('data-dk-es-group', 'true');
          row.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          row.querySelector('.quantity-badge').textContent = String(summary.quantity);
          row.querySelector('.variant').textContent = summary.quantity + ' Kutu';
          row.querySelectorAll('.es-p-discounts').forEach(node => node.remove());
          const price = row.querySelector('.es-p-price');
          const amount = document.createElement('div');
          amount.className = 'fw-bold text-end align-items-center';
          amount.style.whiteSpace = 'nowrap';
          amount.textContent = (summary.price / 100).toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}) + ' TL';
          price.replaceChildren(amount);
          const remove = row.querySelector('.es-close');
          if (displayedCount === 1) remove?.remove();
          else if (remove) {
            remove.setAttribute('role', 'button');
            remove.setAttribute('tabindex', '0');
            remove.setAttribute('aria-label', summary.quantity + ' adet ürünü kaldır');
            const forward = () => original.querySelector('.es-close')?.click();
            remove.addEventListener('click', forward);
            remove.addEventListener('keydown', event => {if (event.key === 'Enter' || event.key === ' ') {event.preventDefault(); forward();}});
          }
          original.before(row);
          for (const item of rows) {
            easyOriginalAria.set(item.node, item.node.getAttribute('aria-hidden'));
            item.node.setAttribute('data-dk-es-original', 'true');
            item.node.setAttribute('aria-hidden', 'true');
          }
        }
      }
    } finally { easyWatch(); }
  };
  const scheduleEasySummary = () => {
    if (!easyObserver || easyScheduled) return;
    easyScheduled = true;
    queueMicrotask(() => {easyScheduled = false; renderEasySummary();});
  };
  const startEasySummary = () => {
    if (!document.body) return;
    const style = document.createElement('style');
    style.textContent = '.es-line-item[data-dk-es-original]{display:none!important}';
    document.head.append(style);
    easyObserver = new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return target?.closest('.es-line-item') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.es-line-item') || node.querySelector('.es-line-item')));
      })) scheduleEasySummary();
    });
    easyWatch();
    scheduleEasySummary();
  };

  let timer;
    let syncInFlight = false;
  let syncAgain = false;
  let cartObserver;
  const sync = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      if (busy || codReading) return;
      if (syncInFlight) {syncAgain = true;return;}
      if (!document.querySelector('cart-items, cart-drawer-items')) return;
      syncInFlight = true;
      try {await normalizeCart(await request('cart.js'));} catch (_) {}
      finally {syncInFlight = false;if (syncAgain) {syncAgain = false;sync();}}
    }, 150);
  };
  const start = () => {
    startEasySummary();
    const hosts = document.querySelectorAll('cart-drawer, cart-items');
    if (!hosts.length) return;
    cartObserver = new MutationObserver(records => {
      const changed = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches('cart-drawer-items, cart-items, .cart-item, input[name="updates[]"]') || node.querySelector('cart-drawer-items, cart-items, .cart-item, input[name="updates[]"]'))
      ));
      if (changed && !busy) sync();
    });
    hosts.forEach(host => cartObserver.observe(host, {childList: true, subtree: true}));
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});else start();
})();

;(() => {
  if(customElements.get('dk-cart-clock')) return;
  customElements.define('dk-cart-clock',class extends HTMLElement {
    connectedCallback(){
      let expiry;
      try {expiry=Number(sessionStorage.getItem('dkCartClockExpiry'));if(!expiry){expiry=Date.now()+600000;sessionStorage.setItem('dkCartClockExpiry',String(expiry));}}catch(_){expiry=Date.now()+600000;}
      const tick=()=>{const left=Math.max(0,Math.ceil((expiry-Date.now())/1000));this.textContent=String(Math.floor(left/60)).padStart(2,'0')+':'+String(left%60).padStart(2,'0');if(!left){this.closest('.dk-cart-clock-bar')?.setAttribute('hidden','');clearInterval(this.clockInterval);}};
      tick();this.clockInterval=setInterval(tick,1000);
    }
    disconnectedCallback(){clearInterval(this.clockInterval);}
  });
})();



